export const FormatsData: import('../../../sim/dex-species').ModdedSpeciesFormatsDataTable = {
	syclar: {
		isNonstandard: "Custom",
		tier: "CAP LC",
	},
	syclant: {
		isNonstandard: "Custom",
		tier: "CAP",
	},
	revenankh: {
		isNonstandard: "Custom",
		tier: "CAP",
	},
	embirch: {
		isNonstandard: "Custom",
		tier: "CAP LC",
	},
	flarelm: {
		isNonstandard: "Custom",
		tier: "CAP NFE",
	},
	pyroak: {
		isNonstandard: "Custom",
		tier: "CAP",
	},
	breezi: {
		isNonstandard: "Custom",
		tier: "CAP LC",
	},
	fidgit: {
		isNonstandard: "Custom",
		tier: "CAP",
	},
	rebble: {
		isNonstandard: "Custom",
		tier: "CAP LC",
	},
	tactite: {
		isNonstandard: "Custom",
		tier: "CAP NFE",
	},
	stratagem: {
		isNonstandard: "Custom",
		tier: "CAP",
	},
	privatyke: {
		isNonstandard: "Custom",
		tier: "CAP LC",
	},
	arghonaut: {
		isNonstandard: "Custom",
		tier: "CAP",
	},
	nohface: {
		isNonstandard: "Custom",
		tier: "CAP LC",
	},
	kitsunoh: {
		isNonstandard: "Custom",
		tier: "CAP",
	},
	monohm: {
		isNonstandard: "Custom",
		tier: "CAP LC",
	},
	duohm: {
		isNonstandard: "Custom",
		tier: "CAP NFE",
	},
	cyclohm: {
		isNonstandard: "Custom",
		tier: "CAP",
	},
	dorsoil: {
		isNonstandard: "Custom",
		tier: "CAP LC",
	},
	colossoil: {
		isNonstandard: "Custom",
		tier: "CAP",
	},
	protowatt: {
		isNonstandard: "Custom",
		tier: "CAP LC",
	},
	krilowatt: {
		isNonstandard: "Custom",
		tier: "CAP",
	},
	voodoll: {
		isNonstandard: "Custom",
		tier: "CAP LC",
	},
	voodoom: {
		isNonstandard: "Custom",
		tier: "CAP",
	},
	scratchet: {
		isNonstandard: "Custom",
		tier: "CAP LC",
	},
	tomohawk: {
		isNonstandard: "Custom",
		tier: "CAP",
	},
	necturine: {
		isNonstandard: "Custom",
		tier: "CAP LC",
	},
	necturna: {
		isNonstandard: "Custom",
		tier: "CAP",
	},
	mollux: {
		isNonstandard: "Custom",
		tier: "CAP",
	},
	cupra: {
		isNonstandard: "Custom",
		tier: "CAP LC",
	},
	argalis: {
		isNonstandard: "Custom",
		tier: "CAP NFE",
	},
	aurumoth: {
		isNonstandard: "Custom",
		tier: "CAP",
	},
	brattler: {
		isNonstandard: "Custom",
		tier: "CAP LC",
	},
	malaconda: {
		isNonstandard: "Custom",
		tier: "CAP",
	},
	cawdet: {
		isNonstandard: "Custom",
		tier: "CAP LC",
	},
	cawmodore: {
		isNonstandard: "Custom",
		tier: "CAP",
	},
	volkritter: {
		isNonstandard: "Custom",
		tier: "CAP LC",
	},
	volkraken: {
		isNonstandard: "Custom",
		tier: "CAP",
	},
	snugglow: {
		isNonstandard: "Custom",
		tier: "CAP LC",
	},
	plasmanta: {
		isNonstandard: "Custom",
		tier: "CAP",
	},
	floatoy: {
		isNonstandard: "Custom",
		tier: "CAP LC",
	},
	caimanoe: {
		isNonstandard: "Custom",
		tier: "CAP NFE",
	},
	naviathan: {
		isNonstandard: "Custom",
		tier: "CAP",
	},
	crucibelle: {
		isNonstandard: "Custom",
		tier: "CAP",
	},
	crucibellemega: {
		isNonstandard: "Custom",
		tier: "CAP",
	},
	pluffle: {
		isNonstandard: "Custom",
		tier: "CAP LC",
	},
	kerfluffle: {
		isNonstandard: "Custom",
		tier: "CAP",
	},
	pajantom: {
		isNonstandard: "Custom",
		tier: "CAP",
	},
	mumbao: {
		isNonstandard: "Custom",
		tier: "CAP LC",
	},
	jumbao: {
		isNonstandard: "Custom",
		tier: "CAP",
	},
	fawnifer: {
		isNonstandard: "Custom",
		tier: "CAP LC",
	},
	electrelk: {
		isNonstandard: "Custom",
		tier: "CAP NFE",
	},
	caribolt: {
		isNonstandard: "Custom",
		tier: "CAP",
	},
	smogecko: {
		isNonstandard: "Custom",
		tier: "CAP LC",
	},
	smoguana: {
		isNonstandard: "Custom",
		tier: "CAP NFE",
	},
	smokomodo: {
		isNonstandard: "Custom",
		tier: "CAP",
	},
	swirlpool: {
		isNonstandard: "Custom",
		tier: "CAP LC",
	},
	coribalis: {
		isNonstandard: "Custom",
		tier: "CAP NFE",
	},
	snaelstrom: {
		isNonstandard: "Custom",
		tier: "CAP",
	},
	justyke: {
		isNonstandard: "Custom",
		tier: "CAP LC",
	},
	equilibra: {
		isNonstandard: "Custom",
		tier: "CAP",
	},
	solotl: {
		isNonstandard: "Custom",
		tier: "CAP LC",
	},
	astrolotl: {
		isNonstandard: "Custom",
		tier: "CAP",
	},
	miasmite: {
		isNonstandard: "Custom",
		tier: "CAP LC",
	},
	miasmaw: {
		isNonstandard: "Custom",
		tier: "CAP",
	},
	chromera: {
		isNonstandard: "Custom",
		tier: "CAP",
	},
	venomicon: {
		isNonstandard: "Custom",
		tier: "CAP",
	},
	venomiconepilogue: {
		isNonstandard: "Custom",
		tier: "CAP",
	},
	saharascal: {
		isNonstandard: "Custom",
		tier: "CAP LC",
	},
	saharaja: {
		isNonstandard: "Custom",
		tier: "CAP",
	},
	ababo: {
		isNonstandard: "Custom",
		tier: "CAP LC",
	},
	scattervein: {
		isNonstandard: "Custom",
		tier: "CAP NFE",
	},
	hemogoblin: {
		isNonstandard: "Custom",
		tier: "CAP",
	},
	cresceidon: {
		isNonstandard: "Custom",
		tier: "CAP",
	},
	chuggon: {
		isNonstandard: "Custom",
		tier: "CAP LC",
	},
	draggalong: {
		isNonstandard: "Custom",
		tier: "CAP NFE",
	},
	chuggalong: {
		isNonstandard: "Custom",
		tier: "CAP",
	},
	shox: {
		isNonstandard: "Custom",
		tier: "CAP",
	},
	ramnarok: {
		isNonstandard: "Custom",
		tier: "CAP",
	},
	ramnarokradiant: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},

	// mostly for advent mons
	ogerponpixiedust: {
		tier: "OU",
		doublesTier: "DOU",
	},
	shakite: {
		tier: "OU",
		doublesTier: "DOU",
	},
	strobite: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	xurkitreesinnoh: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	sandta: {
		isNonstandard: "CAP",
		tier: "CAP",

		doublesTier: "CAP",
	},
	eiscuesnowcone: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	cardemelli: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	gingertar: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	gingertarmega: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	nuzcracker: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	smorgasbag: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	sableyefestive: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	mariahcarey: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	draydol: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	gamesi: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	vipux: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	popsicelf: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	bellbeque: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	chorislam: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	gholdengofestive: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	indeedeecook: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	dulceirene: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	dulceirenemega: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	wreith: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	eternalflowerwreith: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	clamperlalola: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	goodybyss: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	naughtail: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	gospiel: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	rusalvia: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	seraphexe: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	mirrelette: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	klefkimccallister: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	sacchamorte: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	treench: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	grincheartcaged: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	grincheartgrown: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	lelitoccia: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	deckherd: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	caneine: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	picktreebel: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	picktreebelmega: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	twinklingshade: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	irontwilight: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	faerwork: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	antaron: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	snowglob: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	dinjingle: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	guywithsweater: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	gristletoe: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	aegibashpolar: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	gingermason: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	swadloonfestive: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	leavannyfestive: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},
	mausholddysfunctional: {
		isNonstandard: "CAP",
		tier: "CAP",
		doublesTier: "CAP",
	},

};
